import { createApp } from "vue";
import {store} from '@/store/index'
const blacklist = ['website_shared_user']
const install = (app) => {
  app.directive('operation', {
    mounted(el, binding, vnode)
    {
      const name = store.getters?.userInfo?.userName
      if (blacklist.includes(name)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  })
  app.directive("hasPermi", {
    mounted(el, binding, vnode) {
      const { value } = binding
      const all_permission = "*:*:*";
      const permissions = store.getters && store.getters.permissions

      // 过滤出路由的权限
      let isAdmin =
        (permissions?.length && permissions?.includes("*:*:*")) ||
        permissions?.includes("adminFlag") ||
        store.getters.userInfo?.admin;
      // 如果是超管，直接跳出
      if (isAdmin) {
        return true;
      }

      if (value && value instanceof Array && value.length > 0) {
        const permissionFlag = value


        const hasPermissions = permissions && permissions.some(permission => {
          
          return all_permission === permission || permissionFlag.includes(permission) || permissionFlag.includes('*')
        })

        if (!hasPermissions) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      } else {
        throw new Error(`请设置操作权限标签值`)
      }
    }
  });
  
};

export function isCanOperation() {
  const name = store.getters?.userInfo?.userName
  return !blacklist.includes(name)
}

export default {
  install,
};
